const NEWLINE = "\n";

export const LHS =
"<!DOCTYPE html>" + NEWLINE +
"<html lang=en>" + NEWLINE +
"" + NEWLINE +
"<body id=\"main-body\">" + NEWLINE +
"  <p id=\"explanation\">" + NEWLINE +
"    This tool performs structural comparisons of two HTML Documents" + NEWLINE +
"  </p>" + NEWLINE + NEWLINE +
"  <p id=\"pasting\">" + NEWLINE +
"    You can paste two HTML documents in the two text areas above to generate a highlighted comparison." + NEWLINE +
"  </p>" + NEWLINE + NEWLINE +
"  <p id=\"version\" version=\"old\">" + NEWLINE +
"    The old version of the document goes here." + NEWLINE +
"  </p>" + NEWLINE + NEWLINE +
"  <p id=\"attributes\" color=\"#FFFFFF\">" + NEWLINE +
"    For example, if you change the value of an attribute, this tool will highlight the new value in light blue." + NEWLINE +
"  </p>" + NEWLINE + NEWLINE +
"  <p id=\"delete\">" + NEWLINE +
"    If you delete an element, and use the reverse option, this tool will highlight it in red." + NEWLINE +
"  </p>" + NEWLINE + NEWLINE +
"  <p id=\"matching\">" + NEWLINE +
"    <p id=\"b\">" + NEWLINE +
"      This means that elements in different positions but with the same id are not considered to have changed." + NEWLINE +
"    </p>" + NEWLINE + NEWLINE +
"    <p id=\"a\">" + NEWLINE +
"      Elements are matched by id first, but if they have no id they will match by position." + NEWLINE +
"    </p>" + NEWLINE + NEWLINE +
"    <p id=\"tagnames\">" + NEWLINE +
"      Elements that have different tag types are considered completely new elements." + NEWLINE +
"    </p>" + NEWLINE +
"  </p>" + NEWLINE + NEWLINE +
"  <p id=\"changed\">" + NEWLINE +
"    If you change the text of an element, it will appear in the same shade of dark blue." + NEWLINE +
"  </p>" + NEWLINE + NEWLINE +
"  <p id=\"self-closing\">" + NEWLINE +
"    This tool understands self-closing tags." + NEWLINE +
"    <input id=\"old-self-closing\"/>" + NEWLINE +
"    <input id=\"same-self-closing\" color=\"#ff0000\"/>" + NEWLINE +
"  </p>" + NEWLINE + NEWLINE +
"</body>" + NEWLINE +
"" + NEWLINE +
"</html>";

export const RHS =
"<!DOCTYPE html>" + NEWLINE +
"<html lang=en>" + NEWLINE +
"" + NEWLINE +
"<body id=\"main-body\">" + NEWLINE +
"  <p id=\"explanation\">" + NEWLINE +
"    This tool performs structural comparisons of two HTML Documents" + NEWLINE +
"  </p>" + NEWLINE + NEWLINE +
"  <p id=\"pasting\">" + NEWLINE +
"    You can paste two HTML documents in the two text areas above to generate a highlighted comparison." + NEWLINE +
"  </p>" + NEWLINE + NEWLINE +
"  <p id=\"version\" version=\"new\">" + NEWLINE +
"    The new version of the document goes here." + NEWLINE +
"  </p>" + NEWLINE + NEWLINE +
"  <p id=\"attributes\" color=\"#000000\">" + NEWLINE +
"    For example, if you change the value of an attribute, this tool will highlight the new value in light blue." + NEWLINE +
"  </p>" + NEWLINE + NEWLINE +
"  <p id=\"new\">" + NEWLINE +
"    If you add a new element, this tool will highlight it in green." + NEWLINE +
"  </p>" + NEWLINE + NEWLINE +
"  <p id=\"matching\">" + NEWLINE +
"    <p id=\"a\">" + NEWLINE +
"      Elements are matched by id first, but if they have no id they will match by position." + NEWLINE +
"    </p>" + NEWLINE + NEWLINE +
"    <p id=\"b\">" + NEWLINE +
"      This means that elements in different positions but with the same id are not considered to have changed." + NEWLINE +
"    </p>" + NEWLINE + NEWLINE +
"    <textarea id=\"tagnames\">" + NEWLINE +
"      Elements that have different tag types are considered completely new elements." + NEWLINE +
"    </textarea>" + NEWLINE +
"  </p>" + NEWLINE + NEWLINE +
"  <p id=\"changed\">" + NEWLINE +
"    If you change the text of an element, it will appear in dark blue." + NEWLINE +
"  </p>" + NEWLINE + NEWLINE +
"  <p id=\"self-closing\">" + NEWLINE +
"    This tool understands self-closing tags." + NEWLINE +
"    <input id=\"new-self-closing\"/>" + NEWLINE +
"    <input id=\"same-self-closing\" color=\"#10aa88\"/>" + NEWLINE +
"  </p>" + NEWLINE + NEWLINE +
"</body>" + NEWLINE +
"" + NEWLINE +
"</html>";
